import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MainRoute } from 'src/app/models/MainRoute';
import { RoutingService } from 'src/app/services/Routing.service';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ErrorComponent implements OnInit {

  currentRoute: MainRoute;

  constructor() {
    this.currentRoute = RoutingService.getStationRoute();
  }

  ngOnInit(): void {
  }

}
